import { useEffect, useState, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface GPUDevice {
  id: string;
  hostname: string;
  gpu_index: number;
  gpu_uuid: string | null;
  name: string | null;
  driver_version: string | null;
  cuda_version: string | null;
  vbios_version: string | null;
  pci_bus_id: string | null;
  utilization_gpu_percent: number | null;
  utilization_memory_percent: number | null;
  utilization_encoder_percent: number | null;
  utilization_decoder_percent: number | null;
  memory_total_mb: number | null;
  memory_used_mb: number | null;
  memory_free_mb: number | null;
  memory_reserved_mb: number | null;
  temperature_gpu_c: number | null;
  temperature_memory_c: number | null;
  fan_speed_percent: number | null;
  power_draw_w: number | null;
  power_limit_w: number | null;
  power_max_limit_w: number | null;
  clock_graphics_mhz: number | null;
  clock_sm_mhz: number | null;
  clock_memory_mhz: number | null;
  clock_video_mhz: number | null;
  pcie_gen_current: number | null;
  pcie_gen_max: number | null;
  pcie_width_current: number | null;
  pcie_width_max: number | null;
  pcie_tx_throughput_kbs: number | null;
  pcie_rx_throughput_kbs: number | null;
  performance_state: string | null;
  compute_mode: string | null;
  persistence_mode: string | null;
  throttle_reasons: string | null;
  ecc_errors_corrected_total: number | null;
  ecc_errors_uncorrected_total: number | null;
  processes: Array<{ pid: number; process_name: string; used_memory_mb: number; type?: string }>;
  process_count: number;
  last_seen: string;
}

export function useGPUDevices(refreshMs = 10000) {
  const [devices, setDevices] = useState<GPUDevice[]>([]);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    const { data } = await supabase
      .from('gpu_devices')
      .select('*')
      .order('hostname', { ascending: true })
      .order('gpu_index', { ascending: true });
    setDevices((data as any) || []);
    setLoading(false);
  }, []);

  useEffect(() => {
    refetch();
    const id = setInterval(refetch, refreshMs);
    return () => clearInterval(id);
  }, [refetch, refreshMs]);

  return { devices, loading, refetch };
}